/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable */
import React, { useContext, useEffect, useState, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import {
  Grid,
  RACTextbox,
  RACDatePicker,
  RACButton,
  Box,
  Typography,
  RACMUIDatePicker
} from '@rentacenter/racstrap';
import clsx from 'clsx';
import { headerStyles } from '../../../headerStyles';
import { fieldDeviceStyles } from '../../../fieldDeviceSty';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SearchImageDefault } from '../../../assets/images/search-btn.svg';
import moment from 'moment';
import { GetstateDropdown } from '../../../api/user';
import { CustomDropdown } from '../../GlobalSearch/CustomDropdown';
import { useTranslation } from 'react-i18next';
import { MenuContext } from '../../../context/menuContext';
export interface dropdown {
  label: string;
  value: any;
}

export const GlobalSearch = (props: any) => {
  const classes = headerStyles();
  const classes1 = fieldDeviceStyles();
  const history = useHistory();
  const searchCriteriaObject = {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    ssn1: '',
    ssn2: '',
    ssn3: '',
    phoneNumber: '',
    agreementNumber: '',
    addressLine1: '',
    addressLine2: '',
    zip: '',
    city: '',
    state: '',
    curpId: '',
    emailId: '',
    exteriorNumber: '',
    interiorNumber: ''
  };
  const [searchCriteria, setSearchCriteria] = useState(searchCriteriaObject);
  const [disableSearchBtn, setDisableSearchBtn] = useState(true);
  const [datesetting, setDatesetting] = useState('');
  const [minDate, setMinDate] = useState('');
  const DISPLAYSEARCHBAR = 'DISPLAYSEARCHBAR';
  const { t } = useTranslation();
  const {dateTimeLocalization} = useContext(MenuContext);

  const [states, setStates] = useState<dropdown[]>([
    { label: t('Select'), value: '0' },
  ]);
  const [dropDownLoading, setDropDownLoading] = useState<boolean>(false);
  const datePickerInteracting = useRef(false);

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('props.disPlaySearchBar in gbl', props.disPlaySearchBar);
  }, [props.disPlaySearchBar]);

  useEffect(() => {
    fetchDropDowns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.mxCustomerProcess]);

  const fetchDropDowns = async () => {
    try {
      setDropDownLoading(true);
      const dropDownResponse = await GetstateDropdown(props?.mxCustomerProcess ? 'MX' : '');
      const statesDropDown = dropDownResponse;
      console.log('statesDropDown', statesDropDown);
      if (statesDropDown?.length > 0) {
        const formattedStates: dropdown[] =
          getFormatedStatesDropDown(statesDropDown);
        setStates(formattedStates);
      }
    } catch (e: any) {
      console.error(e);
    } finally {
      setDropDownLoading(false);
    }
  };

  const getFormatedStatesDropDown = (statesDropDown: any, location?: any) => {
    const states = statesDropDown.map((data: any) => ({
      label: data.stateAbbreviation,
      value: location ? data.stateProvinceId : data.stateAbbreviation,
    }));

    const sortedStates = states.sort((a: any, b: any) =>
      a.label.localeCompare(b.label)
    );
    return [{ label: t('Select'), value: '0' }, ...sortedStates];
  };

  useEffect(() => {
    if (
      searchCriteria.firstName.length + searchCriteria.lastName.length >= 3 ||
      searchCriteria.dateOfBirth ||
      searchCriteria.phoneNumber.length == 14 ||
      searchCriteria.agreementNumber.trim().length >= 4 ||
      searchCriteria.addressLine1.trim().length >= 5 ||
      searchCriteria.addressLine2.trim().length >= 5 ||
      searchCriteria.city.trim().length >= 3 ||
      (searchCriteria.state.length > 1 && searchCriteria.state !== 'Select') ||
      searchCriteria.zip.length > 1 ||
      searchCriteria.ssn1.length +
      searchCriteria.ssn2.length +
      searchCriteria.ssn3.length ==
      9 ||
      searchCriteria.exteriorNumber.length >=1 ||
      searchCriteria.interiorNumber.length>=1 ||
      searchCriteria.curpId.length >=1 ||
      searchCriteria.emailId.length >= 1
    ) {
      setDisableSearchBtn(false);
    } else {
      setDisableSearchBtn(true);
    }
  }, [searchCriteria]);

  useEffect(() => {
    setDatesetting(moment().subtract(18, 'years').format('YYYY-MM-DD'));
    setMinDate(moment().subtract(110, 'years').format('YYYY-MM-DD'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchHandler = (e: any, src: any) => {
    const updateSearchCriteria = (name: string, value: any) => {
      setSearchCriteria((prev) => ({ ...prev, [name]: value }));
    };

    const handleSSNFocus = (
      currentElId: string,
      nextElId: string,
      length: number
    ) => {
      const currentEl: any = document.getElementById(currentElId);
      const nextEl: any = document.getElementById(nextElId);
      if (
        currentEl.value.replace(/[^0-9\b]/gi, '').length === length &&
        currentEl === document.activeElement
      ) {
        nextEl.focus();
      }
    };

    switch (src) {
      case 'NAME':
        const nameRegex = props?.mxCustomerProcess ? /[^A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü'.,’ -]+$/gi : /[^A-Z-',.; a-z]/gi
        updateSearchCriteria(
          e.target.name,
          e.target.value.replace(nameRegex, '')
        );
        break;
      case 'DOB':
        updateSearchCriteria('dateOfBirth', e);
        break;
      case 'PHONE':
      case 'agreementNumber':
      case 'addressLine1':
      case 'addressLine2':
      case 'city':
      case 'curpId':
      case 'emailId':
      case 'interiorNumber':
      case 'exteriorNumber':
        updateSearchCriteria(e.target.name, e.target.value);
        break;
      case 'state':
        updateSearchCriteria(src, e);
        break;
      case 'SSN1':
        updateSearchCriteria(
          e.target.name,
          e.target.value.replace(/[^0-9\b]/gi, '')
        );
        handleSSNFocus('a11y_ssn1', 'a11y_ssn2', 3);
        break;
      case 'SSN2':
        updateSearchCriteria(
          e.target.name,
          e.target.value.replace(/[^0-9\b]/gi, '')
        );
        handleSSNFocus('a11y_ssn2', 'a11y_ssn3', 2);
        handleSSNFocus('a11y_ssn2', 'a11y_ssn1', 0);
        break;
      case 'SSN3':
        updateSearchCriteria(
          e.target.name,
          e.target.value.replace(/[^0-9\b]/gi, '')
        );
        handleSSNFocus('a11y_ssn3', 'a11y_ssn2', 0);
        break;
      case 'zip':
        updateSearchCriteria(e.target.name, e.target.value);
        break;
      default:
        break;
    }
  };

  const invokeRedirection = () => {
    clickedOutside();
    history.push({
      pathname: '/customer/searchcustomer',
      state: {
        FirstName: searchCriteria.firstName,
        LastName: searchCriteria.lastName,
        DOB: searchCriteria.dateOfBirth,
        PhoneNumber: searchCriteria.phoneNumber.replace(/\D/g, ''),
        SSN1: searchCriteria.ssn1,
        SSN2: searchCriteria.ssn2,
        SSN3: searchCriteria.ssn3,
        agreementNumber: searchCriteria.agreementNumber,
        addressLine1: searchCriteria.addressLine1,
        addressLine2: searchCriteria.addressLine2,
        zip: searchCriteria.zip,
        city: searchCriteria.city,
        state: searchCriteria.state,
        curpId: searchCriteria.curpId,
        emailId: searchCriteria.emailId,
        exteriorNumber: searchCriteria.exteriorNumber,
        interiorNumber: searchCriteria.interiorNumber,
        originCountry: props?.mxCustomerProcess ? "MX" : undefined
      },
    });
  };

  const clickedOutside = () => {
    if (datePickerInteracting.current) {
      return;
    }
    // eslint-disable-next-line no-console
    console.log('Reached the outside click1234');
    setSearchCriteria(searchCriteriaObject);
    props.searchOutsideClick('');
  };

  const enterEncountered = (e: any) => {
    if (e.key === 'Enter' && !disableSearchBtn) {
      invokeRedirection();
    }
  };

  function MXFirstRowDependency() {
    return (
      <Grid container spacing={2}>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="lastName"
            value={searchCriteria.lastName}
            placeHolder={t('Paternal Last Name')}
            inputlabel={t('Paternal Last Name')}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'NAME')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="firstName"
            inputlabel={t('First Name')}
            placeHolder={t('First Name')}
            value={searchCriteria.firstName}
            maxlength={30}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
            OnChange={(event) => searchHandler(event, 'NAME')}
          />
        </Grid>
        <Grid item md={4} lg={2} sm={6} className={classes.datePicker}>
          <Box
            component="div"
            className={`${classes.formLabel} ${classes.datePickerAddCo}`}
          >
            {t('Date of Birth')}
          </Box>
          <div 
            onMouseDown={() => datePickerInteracting.current = true}
            onMouseUp={() => setTimeout(() => datePickerInteracting.current = false, 100)}
          >
            {
            dateTimeLocalization ?
              <div className={classes.MUIDatePicker}>
                <RACMUIDatePicker
                  label=""
                  value={searchCriteria.dateOfBirth}
                  name={'Dob'}
                  onChange={(event: any) => {
                    searchHandler(event, 'DOB');
                    setTimeout(() => datePickerInteracting.current = false, 100);
                  }}
                  inputProps={{ max: datesetting, min: minDate }}
                />
              </div>

                 :
                <RACDatePicker
                  id="a11y_dob"
                  label=""
                  value={searchCriteria.dateOfBirth}
                  name={'Dob'}
                  onChange={(event: any) => searchHandler(event, 'DOB')}
                  inputProps={{ max: datesetting, min: minDate }}
                />
            }
          </div>
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="curpId"
            inputlabel={t('CURP')}
            value={searchCriteria.curpId}
            placeHolder={t('CURP')}
            maxlength={30}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
            OnChange={(event) => searchHandler(event, 'curpId')}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="phoneno"
            maxlength={14}
            inputlabel={t('Phone Number')}
            placeHolder={t('Phone Number')}
            id="a11y_phonenumber"
            name="phoneNumber"
            value={searchCriteria.phoneNumber}
            OnChange={(event) => searchHandler(event, 'PHONE')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
            pattern="\D*"
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            maxlength={254}
            inputlabel={('Email')}
            placeHolder={('Email')}
            id="a11y_emailId"
            name="emailId"
            value={searchCriteria.emailId}
            OnChange={(event) => searchHandler(event, 'emailId')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            maxlength={19}
            inputlabel={t("Agreement #")}
            id="a11y_agreementumber"
            name="agreementNumber"
            placeHolder={t("Agreement #")}
            value={searchCriteria.agreementNumber}
            OnChange={(e: any) => searchHandler(e, 'agreementNumber')}
            isCurrency={false}
            onKeyPress={(e: any) => enterEncountered(e)}
          />
        </Grid>
      </Grid>
    );
  }

  function MXSecondRowDependency() {
    return (
      <Grid container spacing={2}>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="addressLine1"
            placeHolder={t('Street')}
            inputlabel={t('Street')}
            maxlength={30}
            value={searchCriteria.addressLine1}
            inputLabelClassname={classes.mb1}
            OnChange={(event) => searchHandler(event, 'addressLine1')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="exteriorNumber"
            placeHolder={t('Exterior Number')}
            inputlabel={t('Exterior Number')}
            value={searchCriteria.exteriorNumber}
            inputLabelClassname={classes.mb1}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'exteriorNumber')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="interiorNumber"
            placeHolder={t('Interior Number')}
            inputlabel={t('Interior Number')}
            value={searchCriteria.interiorNumber}
            inputLabelClassname={classes.mb1}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'interiorNumber')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="addressLine2"
            placeHolder={t('Suburb')}
            inputlabel={t('Suburb')}
            value={searchCriteria.addressLine2}
            inputLabelClassname={classes.mb1}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'addressLine2')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="zip"
            inputlabel={t('Zip code')}
            placeHolder={t('Zip code')}
            maxlength={10}
            minlength={5}
            value={searchCriteria.zip}
            inputLabelClassname={classes.mb1}
            OnChange={(e) => {
              let zipCode = ('' + e.target.value).replace(/\D/g, '');
              zipCode =
                zipCode.length > 5
                  ? zipCode.slice(0, 5) + '-' + zipCode.slice(5)
                  : zipCode;
              e.target.name = 'zip';
              e.target.value = zipCode;
              searchHandler(e, 'zip');
            }}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="city"
            inputlabel={t('City')}
            value={searchCriteria.city}
            placeHolder={t('City')}
            maxlength={30}
            inputLabelClassname={classes.mb1}
            OnChange={(event) => searchHandler(event, 'city')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
      </Grid>
    );
  }


  function MXThirdRowDependency() {
    return (
      <Grid container spacing={2} style={{
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
        marginTop: '10px'
      }}>
        <Grid item lg={2} md={4} sm={6}>
          {
            <CustomDropdown
              states={states}
              selection={(value) => searchHandler(value, 'state')}
              defaultValue={searchCriteria.state}
              loading={dropDownLoading}
              inputLabel={t('State')}
              isDisabled={false}
            />
          }
        </Grid>
        <Grid item lg="auto" md={4} sm={6} style={{ display: 'flex', alignItems: 'flex-start', gap: '1%', justifyContent: 'flex-end' }}>
          <RACButton
            variant="outlined"
            color="primary"
            style={{ margin: '15px 10px 0px 0px' }}
            disabled={
              searchCriteria.firstName.length === 0 &&
                searchCriteria.lastName.length === 0 &&
                searchCriteria.dateOfBirth.length === 0 &&
                searchCriteria.phoneNumber.length === 0 &&
                searchCriteria.addressLine1.length === 0 &&
                searchCriteria.addressLine2.length === 0 &&
                searchCriteria.interiorNumber.length === 0 &&
                searchCriteria.emailId.length === 0 &&
                searchCriteria.curpId.length === 0 &&
                searchCriteria.zip.length === 0 &&
                searchCriteria.city.length === 0 &&
                searchCriteria.state.length === 0 &&
                searchCriteria.exteriorNumber.length ===0 &&
                searchCriteria.agreementNumber.length ===0
                ? true
                : false
            }
            data-testid="clrbtn"
            onClick={() => {
              setSearchCriteria(searchCriteriaObject);
            }}
          >
            {t('Clear')}
          </RACButton>
          <RACButton
            startIcon={<SearchImageDefault />}
            disabled={disableSearchBtn}
            variant="contained"
            color="primary"
            size="small"
            className={classes.racSearchPrimary}
            onClick={invokeRedirection}
          >
            {t('Search')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }

  function FirstRowDependency() {
    return (
      <>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="lastName"
            value={searchCriteria.lastName}
            inputlabel={t('Last Name')}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'NAME')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="firstName"
            inputlabel={t('First Name')}
            value={searchCriteria.firstName}
            maxlength={30}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
            OnChange={(event) => searchHandler(event, 'NAME')}
          />
        </Grid>
        <Grid item md={4} lg={2} sm={6} className={classes.datePicker}>
          <Box
            component="div"
            className={`${classes.formLabel} ${classes.datePickerAddCo}`}
          >
            {t('Date of Birth')}
          </Box>
          <RACDatePicker
            id="a11y_dob"
            label=""
            value={searchCriteria.dateOfBirth}
            name={'Dob'}
            onChange={(event: any) => searchHandler(event, 'DOB')}
            inputProps={{ max: datesetting, min: minDate }}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6} className={classes.spacerPT1}>
          <label htmlFor="a11y_ssn" className={classes.formLabel}>
            {t('Social Security# / ITIN#')}
          </label>
          <Grid container spacing={2} className={classes.ssnpadding}>
            <Grid item md={4} sm={4}>
              <RACTextbox
                type="password"
                name="ssn1"
                value={searchCriteria.ssn1}
                placeHolder={'xxx'}
                id="a11y_ssn1"
                className={classes.textCenterSSN}
                maxlength={3}
                OnChange={(event) => searchHandler(event, 'SSN1')}
                isCurrency={false}
              />
            </Grid>
            <Grid item md={3} sm={3}>
              <RACTextbox
                type="password"
                name="ssn2"
                value={searchCriteria.ssn2}
                placeHolder={'xx'}
                id="a11y_ssn2"
                className={classes.textCenterSSN}
                maxlength={2}
                OnChange={(event) => searchHandler(event, 'SSN2')}
                isCurrency={false}
              />
            </Grid>
            <Grid item md={5} sm={5}>
              <RACTextbox
                type="text"
                name="ssn3"
                value={searchCriteria.ssn3}
                placeHolder="xxxx"
                id="a11y_ssn3"
                className={classes.textCenterSSN}
                maxlength={4}
                OnChange={(event) => searchHandler(event, 'SSN3')}
                isCurrency={false}
                OnKeydown={(e) => enterEncountered(e)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="phoneno"
            maxlength={14}
            inputlabel={t('Phone Number')}
            id="a11y_phonenumber"
            name="phoneNumber"
            value={searchCriteria.phoneNumber}
            OnChange={(event) => searchHandler(event, 'PHONE')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
            pattern="\D*"
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            maxlength={19}
            inputlabel={t('Agreement #')}
            id="a11y_agreementumber"
            name="agreementNumber"
            value={searchCriteria.agreementNumber}
            OnChange={(event) => searchHandler(event, 'agreementNumber')}
            isCurrency={false}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
      </>
    );
  }

  function secondRowFirstDependency() {
    return (
      <>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="addressLine1"
            placeHolder={t('Address Line 1')}
            inputlabel={t('Address Line 1')}
            maxlength={30}
            value={searchCriteria.addressLine1}
            inputLabelClassname={classes.mb1}
            OnChange={(event) => searchHandler(event, 'addressLine1')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item lg={2} md={4} sm={6}>
          <RACTextbox
            type="text"
            name="addressLine2"
            placeHolder={t('Address 2, APT #, Unit #, P.O. Box')}
            inputlabel={t('Apt/Unit #')}
            value={searchCriteria.addressLine2}
            inputLabelClassname={classes.mb1}
            maxlength={30}
            OnChange={(event) => searchHandler(event, 'addressLine2')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
      </>
    );
  }

  function secondRowSecondDependency() {
    return (
      <Grid container spacing={2} className={`${classes.ms2}`} md={4}>
        <Grid item md={4}>
          <RACTextbox
            type="text"
            name="zip"
            inputlabel={t('Zip')}
            placeHolder={t('Zip code')}
            maxlength={10}
            minlength={5}
            value={searchCriteria.zip}
            inputLabelClassname={classes.mb1}
            OnChange={(e) => {
              let zipCode = ('' + e.target.value).replace(/\D/g, '');
              zipCode =
                zipCode.length > 5
                  ? zipCode.slice(0, 5) + '-' + zipCode.slice(5)
                  : zipCode;
              e.target.name = 'zip';
              e.target.value = zipCode;
              searchHandler(e, 'zip');
            }}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>

        <Grid item md={4}>
          <RACTextbox
            type="text"
            name="city"
            inputlabel={t('City')}
            value={searchCriteria.city}
            placeHolder={t('City')}
            maxlength={30}
            inputLabelClassname={classes.mb1}
            OnChange={(event) => searchHandler(event, 'city')}
            OnKeydown={(e) => enterEncountered(e)}
          />
        </Grid>
        <Grid item md={4}>
          {
            <CustomDropdown
              states={states}
              selection={(value) => searchHandler(value, 'state')}
              defaultValue={searchCriteria.state}
              loading={dropDownLoading}
              inputLabel={t('State')}
              isDisabled={false}
            />
          }
        </Grid>
      </Grid>
    );
  }

  const MXCustomerSearch = () => {
    return (
      <>
        <Grid item md={12} style={{padding: '0px'}}>
          <Typography variant="h3" className={classes.widgetTitle}>
            {t("Basic Information")}
          </Typography>
        </Grid>
        {MXFirstRowDependency()}
        <Grid style={{ marginTop: '20px' }}>
          <Typography variant="h3" className={classes.widgetTitle}>
            {t("Address Information")}
          </Typography>
        </Grid>
        {MXSecondRowDependency()}
        {MXThirdRowDependency()}
      </>
    )
  }

  const NonMXCustomerSearch = () => {
    return (
      <>
        {FirstRowDependency()}
        {secondRowFirstDependency()}
        {secondRowSecondDependency()}
      </>
    )
  }

  return (
    <OutsideClickHandler onOutsideClick={clickedOutside}>
      <Grid
        data-testid="searchbtn"
        className={clsx({
          [classes.racGlobalSearchShow]:
            props.disPlaySearchBar == DISPLAYSEARCHBAR,
        })}
        classes={{
          root: clsx(classes.racDropdownMenu, classes.racMenuContent),
        }}
        aria-labelledby="navbarglobalsearch"
      >
        <Grid
          container
          spacing={2}
          className={`${classes.px2} ${classes.mb3} ${classes1.p3}`}
        >
          {props?.mxCustomerProcess ? MXCustomerSearch() : NonMXCustomerSearch()}
          {!props?.mxCustomerProcess ?
            <Grid item lg="auto" md={4} sm={6}>
              <RACButton
                startIcon={<SearchImageDefault />}
                disabled={disableSearchBtn}
                variant="contained"
                color="primary"
                size="small"
                className={classes.racSearchPrimary}
                onClick={invokeRedirection}
              >
                {t('Search')}
              </RACButton>
            </Grid> : null}
        </Grid>
      </Grid>
    </OutsideClickHandler>
  );
};